import { useSyncExternalStore } from 'react'

/*
 * Operator actions on a node, shown in the console event list (ConsoleEvents):
 * UTC time, the user icon, the node as the subject, one sentence. Rows are not
 * coloured by state. The list lives for this page session; the center's journal
 * does not carry these until it records them.
 */

export interface OperatorEvent {
  id: string
  at: string
  nodeId: string
  name: string
  text: string
}

let events: OperatorEvent[] = []
const listeners = new Set<() => void>()

export function pushOperatorEvent(e: Omit<OperatorEvent, 'id'>): void {
  events = [{ ...e, id: `${e.at}-${e.nodeId}-${events.length}` }, ...events]
  listeners.forEach((l) => l())
}

function subscribe(cb: () => void) {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

export function useOperatorEvents(nodeId: string): OperatorEvent[] {
  const all = useSyncExternalStore(subscribe, () => events, () => events)
  return all.filter((e) => e.nodeId === nodeId)
}

/** HH:MM:SS in UTC. The rest of the console still uses the viewer's zone. */
export function utcClock(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  const p = (n: number) => String(n).padStart(2, '0')
  return `${p(d.getUTCHours())}:${p(d.getUTCMinutes())}:${p(d.getUTCSeconds())}`
}
